import { useEffect } from "react";
import { Dialog } from "@/components/common/Dialog";
import { useDocumentPreviewStore } from "@/stores/document-preview-store";
import { useAuthStore } from "@/stores/auth-store";
import { DocumentView } from "./DocumentView";

export function DocumentPreviewHost() {
  const resource = useDocumentPreviewStore(state => state.resource);
  const close = useDocumentPreviewStore(state => state.close);
  useEffect(() => {
    const unsubscribe = useAuthStore.subscribe((state, previous) => {
      if (state.status !== previous.status || state.profile?.sub !== previous.profile?.sub) close();
    });
    return () => { unsubscribe(); close(); };
  }, [close]);
  if (!resource) return null;
  return <Dialog id="document-preview-dialog" closeId="document-preview-close" open onClose={close} dismiss="light" maxWidth="xl" title={<span className="break-words">{resource.name}</span>}>
    <DocumentView variant="viewer" file={resource} />
  </Dialog>;
}
